import apiClient from "../apiClient";

/**
 * Token API Service
 * Verwaltet API-Tokens für die Mobile App Authentifizierung
 */

// Alle Tokens des Benutzers abrufen
export const getTokens = async () => {
  const response = await apiClient.get("/api/tokens/");
  return response.data;
};

// Nur aktive Tokens abrufen
export const getActiveTokens = async () => {
  const response = await apiClient.get("/api/tokens/active/");
  return response.data;
};

// Neuen Token erstellen
export const createToken = async (tokenData) => {
  const response = await apiClient.post("/api/tokens/", tokenData);
  return response.data;
};

// Token löschen
export const deleteToken = async (tokenId) => {
  const response = await apiClient.delete(`/api/tokens/${tokenId}/`);
  return response.data;
};

// Token widerrufen (deaktivieren)
export const revokeToken = async (tokenId) => {
  const response = await apiClient.post(`/api/tokens/${tokenId}/revoke/`);
  return response.data;
};

export default {
  getTokens,
  getActiveTokens,
  createToken,
  deleteToken,
  revokeToken,
};
